<template>
  <div class="mainmenu-holder" :class="{open: sideopen}" v-if="showmenu">
    <i class="openclose" @click="sideopen = !sideopen"></i>
    <nav class="mainmenu" :class="{open: sideopen}">
      <template v-if="user && user.length">
        <span v-for="(route, i) in routes" :key=i>
          <router-link-i18n :to="route" id="BountyCampaignTwittercampaign" v-if="route.name == 'bounty.campaign.twittercampaign'" :class="route.name.replace(/\./g, '_')" @click.native="clicked(route)">
            <Icon v-if="route.meta.icon" :name="route.meta.icon" />
            <span v-if="route.meta.title">{{ route.meta.title | text }}</span>
            <span v-else-if="route.meta.trans">{{ route.meta.trans | trans }}</span>
          </router-link-i18n>
          <router-link-i18n :to="route" v-else :class="route.name.replace(/\./g, '_')" @click.native="clicked(route)">
            <Icon v-if="route.meta.icon" :name="route.meta.icon" />
            <span v-if="route.meta.title">{{ route.meta.title | text }}</span>
            <span v-else-if="route.meta.trans">{{ route.meta.trans | trans }}</span>
          </router-link-i18n>
          <nav v-if="route.children.length">
            <span v-for="(sroute, j) in route.children" :key=j>
              <router-link-i18n :to="sroute" @click.native="clicked(true)">
                <Icon v-if="sroute.meta.icon" :name="sroute.meta.icon" />
                <span v-if="sroute.meta.title">{{ sroute.meta.title }}</span>
                <span v-else-if="sroute.meta.trans">{{ sroute.meta.trans | trans }}</span>
              </router-link-i18n>
            </span>
          </nav>
        </span>
      </template>

      <router-link-i18n
        v-if="back && back.name"
        :to="{name:back.name}"
        @click.native="clicked(true)"
        class="backlink"
      >
        <i class="btn"><Icon name=arrow /></i>
        <span>{{ 'buttons.back' | trans }}</span>
      </router-link-i18n>
    </nav>
  </div>
</template>

<script>
  export default {
    data() {return {
      links: [
        'dashboard',
        'users',
        'apps',
        'billings',
        'apptokens.apps',
      ],
      sideopen: false,
    }},
    computed: {
      back () {
        return this.stableParent(this.getParent(this.$route));
      },
      trueBase () {
        if (!this.currentBase) {
          return;
        }
        return this.stableParent(this.currentBase);
      },
      currentBase () {
        return this.findBase(this.$router.options.routes, null);
      },
      allFlat () {
        return this.flattenRoutes(this.$router.options.routes);
      },
      user () {return this.$store.getters.user;},
      routes () {
        if (!this.currentBase) {
          return [];
        }
        var routes = this.getChildren(this.currentBase)
          //.map(name => this.$router.match({name}).matched[1])
          .filter(r => r && r.meta) //only those with meta
          .filter(r => (r.meta.title || r.meta.trans) && !r.meta.root) //only those with title
          .filter(r => !r.meta.restrict || r.meta.restrict(this.$store)) //check if restricted
        ;
        routes.forEach((route, i) => {
          routes[i] = Object.assign({}, route);
          routes[i].children = this.getChildren(route)
              .filter(r => r.meta && r.meta.menu && (r.meta.title || r.meta.trans));
        });
        return routes.filter(r => !r.meta || r.meta.menu !== false);
      },
      showmenu () {
        return this.routes.length > 1;
      },
    },
    methods: {
      stableParent (r) {
        if (Array.isArray(r)) {
          if (!r.length) {
            return false;
          }
          r = r[0];
        }
        if (!r || !r.redirect) {
          return r;
        }
        return this.stableParent(this.allFlat.filter(f => {
          if (r.meta && r.meta.up) {
            return f.name === r.meta.up;
          } else if (r.name && f.children) {
            return f.children.map(c=>c.name).includes(r.name);
          }
        }));
      },
      clicked (route) {
        if (route === true || !route.children || !route.children.length) {
          this.sideopen = false;
        }
      },
      flattenRoutes (routes) {
        return [].concat(
          routes,
          routes.reduce((list, current) => list.concat(this.flattenRoutes(current.children || [])), [])
        );
      },
      getChildren (route) {
        var direct = route.children || (route.meta && route.meta.children) || [];
        var remaining = direct.filter(c => !c.meta || !c.meta.up || c.meta.up === route.name || c.meta.root);
        var other = this.allFlat.filter(c => c.meta && c.meta.up && c.meta.up === route.name);
        return [].concat(remaining, other).reduce((list, current) => {
          if (!list.includes(current)) {
            list.push(current);
          }
          return list;
        }, []);
      },
      getParent (route) {
        if (route.meta && route.meta.up) {
          var namedup = this.allFlat.filter(f => f.name === route.meta.up);
          if (!namedup.length) {
            return false;
          }
          return namedup[0];
        } else {
          var realup = this.allFlat.filter(f =>
            f.children && f.children.map(c => c.name).includes(route.name)
          );
          if (!realup.length) {
            return false;
          }
          return realup[0];
        }
      },
      findBase (routes, base) { //find current route in all routes and find its base
        for (let route of routes) {
          if (route.name === this.$route.name) {
            return base;
          }
          let inbase = base;
          if (route.meta && route.meta.root) {
            inbase = route;
          }
          let routeChildren = this.getChildren(route);
          if (routeChildren.length) {
            let innerResult = this.findBase(routeChildren, inbase);
            if (innerResult) {
              return innerResult;
            }
          }
        }
        return null;
      },
    },
  }
</script>

<style lang="scss">
div.mainmenu-holder {
  overflow: visible;
  position: fixed;
  z-index: 3;
  nav.mainmenu {
    position: fixed;
    z-index: 3;
    left: 0;
    top: $breadcrumbs-height;
    bottom: 0;
    width: $mainmenu-width;
    padding-top: 25px;
    @extend %sidemenu;
    > span {
      margin: 20px 0;
      @media (min-width: $md-min) {
        &:last-of-type:not(:last-child) {
          margin-bottom: 60px;
        }
      }
    }
    > span > a {
      padding-left: 60px;
      svg {
        position: absolute;
        top: calc(50% - 14px);
        left: 15px;
        width: 28px;
      }
    }
    @media (max-width: $sm-max) {
      box-shadow: 0 0 18px 0 $inverse-border;
      left: -$mainmenu-width - 18px;
      transition: left .25s;
      &.open {
        left: 0;
      }
    }
    > .backlink {
      display: block;
      text-align: center;
      @media (min-width: $md-min) {
        position: fixed;
        bottom: 0;
        left: 0;
        width: $mainmenu-width - 6px;
      }
      white-space: nowrap;
      padding: 10px 0;
      > * {
        display: inline-block;
        vertical-align: middle;
      }
      .btn {
        min-width: 70px;
        .svg-icon {
          transform: rotate(-90deg);
        }
      }
      span {
        text-transform: uppercase;
        font-weight: 700;
        @include font-size(22px);
      }
    }
    @include paint_menu($inverse-bg, $inverse-color, $body-bg, $default-border, $accent);
  }
  @media (min-width: $md-min) {
    + *:not(.wizard) {
      margin-left: $mainmenu-width;
    }
  }
  i.openclose {
    display: none;
    @media (max-width: $sm-max) {
      display: inline-block;
      width: $breadcrumbs-height - 8px;
      height: $breadcrumbs-height - 8px;
      position: fixed;
      top: 4px;
      left: 4px;
      border: solid $accent 2px;
      border-radius: 5px;
      &::before {
        $pad: 4px;
        $thick: 4px;
        content: '';
        display: inline-block;
        position: absolute;
        top: #{($breadcrumbs-height - 8px - $thick - 4px)/2};
        left: $pad;
        width: #{$breadcrumbs-height - 8px - 2*$pad - 4px};
        height: $thick;
        background: $accent;
        box-shadow: 0 8px 0 0 $accent, 0 #{-8px} 0 0 $accent;
      }
    }
  }
}
@media (max-width: $sm-max) and (min-width: $mainmenu-width) {
  div.mainmenu-holder.open i.openclose::after {
    content: '';
    display: block;
    position: fixed;
    top: $breadcrumbs-height;
    right: 0;
    bottom: 0;
    width: calc(100% - #{$mainmenu-width});
    width: calc(100vw - #{$mainmenu-width});
    background: rgba(black, .01);
  }
}
</style>



// WEBPACK FOOTER //
// src/Mainmenu.vue